import React from "react"
import { createBrowserRouter, type RouteObject } from "react-router-dom"

import CentralStation from "./views/CentralStation"
import FormOneDevolucao from "./views/FormOneDevolucao"
import FormOneEntrega from "./views/FormOneEntrega"
import Workspace from "./views/Workspace"

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Workspace />,
    children: [
      {
        path: "",
        element: <CentralStation pages={[
          { imgSrc: "https://dezprbe52xhim.cloudfront.net/BrandLogos/kinto-one-checklist-entrega.png", label: "teste", route: "/one/entrega" },
          { imgSrc: "https://dezprbe52xhim.cloudfront.net/BrandLogos/kinto-one-checklist-devolucao.png", label: "teste", route: "/one/devolucao", hidden: true },
          { imgSrc: "https://dezprbe52xhim.cloudfront.net/BrandLogos/kinto-one-checklist-sinistro.png", label: "teste", route: "/one/sinistro", hidden: true }
        ]} />
      },
      {
        path: "one",
        children: [
          {
            path: "entrega",
            element: <FormOneEntrega />
          },
          {
            path: "devolucao",
            element: <FormOneDevolucao />
          }
        ]
      }
    ]
  }
]

function router () {
  return createBrowserRouter(routes)
}

export default router
